import { Product } from "./Products";

export const COMPANY_SIZES = [
  5,
  10,
  30,
  50,
  100,
  150,
  250,
  500,
  1000,
  2500,
  5000,
  "unlimited",
];

type Platforms = "desktop" | "web" | "app" | "logo";
export const PLATFORMS: Platforms[] = ["desktop", "web", "app", "logo"];

export interface LicenseUsageState {
  license_usage_on_behalf_of: boolean | null;
  license_usage_for_education: boolean | null;
}

type CompanySize = number | string;

export interface LicenseHolderState {
  license_holder_name: string;
  license_holder_email_address: string;
  license_holder_company_size: { [k: CompanySize]: boolean };
  addons_share_with_third_party: boolean;
}

export interface LicenseTypesState {
  desktop: boolean;
  web: boolean;
  app: boolean;
  logo: boolean;
}

export interface LicenseStylesState {
  bundles: { [bundleProductId: number]: boolean };
  styles: { [styleProductId: number]: boolean };
}

export interface LicenseUsage {
  isEducationalLicense: boolean;
  isOnBehalfOfSomeoneElse: boolean;
}

export type LicenseHolderCompanySize = number | "unlimited";

export interface LicenseHolder {
  name: string;
  emailAddress: string;
  companySize: LicenseHolderCompanySize | "";
  addOns: {
    shareWithThirdParty: boolean;
  };
}

export type FamilyDetails = {
  platforms: string[];
  items: Product[];
};

export type CartFamilies = {
  [k: string]: FamilyDetails;
};
